var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showed)?_c('div',{class:{
    'disabled-payment': _vm.disabled,
  },attrs:{"id":"paypal-button"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }